module.exports = __webpack_public_path__ + "static/wkkellogg-logo-bf8bde8456193126435afdd3c876fb23.png";